import React from 'react';
import { TargetIcon, CheckIcon } from 'lucide-react';
export function WhoShouldUse() {
  const targetUsers = ['SaaS companies replacing their chatbot', 'Healthcare platforms automating care', 'Sales & marketing teams who want AI that sells', 'Agencies or startups building a killer voice UX', 'Enterprises seeking always-on, humanlike service without human costs'];
  return <section className="w-full py-20 px-6 md:px-10 lg:px-20 bg-[#111]" data-id="element-269">
      <div className="max-w-5xl mx-auto" data-id="element-270">
        <div className="flex items-center mb-6" data-id="element-271">
          <TargetIcon className="w-6 h-6 text-[#00E0FF] mr-3" data-id="element-272" />
          <h2 className="text-lg font-semibold uppercase tracking-wider text-[#00E0FF]" data-id="element-273">
            Who Should Use Critical Voice
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-274">
          <div data-id="element-275">
            <h3 className="text-3xl font-bold mb-8" data-id="element-276">
              Built for Forward-Thinking Teams
            </h3>
            <ul className="space-y-4" data-id="element-277">
              {targetUsers.map((user, index) => <li key={index} className="flex items-start" data-id="element-278">
                  <div className="w-6 h-6 rounded-full bg-[#3F00FF]/20 flex items-center justify-center mr-4 mt-1" data-id="element-279">
                    <CheckIcon className="w-4 h-4 text-[#00E0FF]" data-id="element-280" />
                  </div>
                  <p className="text-lg" data-id="element-281">{user}</p>
                </li>)}
            </ul>
          </div>
          <div className="bg-[#222] rounded-xl p-8 border border-gray-800" data-id="element-282">
            <h3 className="text-xl font-bold mb-4" data-id="element-283">Are You Ready?</h3>
            <p className="text-gray-300 mb-6" data-id="element-284">
              If you're looking to transform how your business communicates with
              users, Critical Voice offers the most advanced, human-like AI
              voice technology available today.
            </p>
            <p className="text-gray-300" data-id="element-285">
              Our clients typically see 3-5x higher engagement compared to
              text-based chatbots, and conversion rates that exceed human agents
              by 20-30%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}